import { render, staticRenderFns } from "./RunnitsHome.vue?vue&type=template&id=56b407c6&scoped=true"
import script from "./RunnitsHome.vue?vue&type=script&lang=ts"
export * from "./RunnitsHome.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsHome.vue?vue&type=style&index=0&id=56b407c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b407c6",
  null
  
)

export default component.exports